import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/plugins/vant';
import '@/plugins/xl-m-ui';
import '@/assets/styles/index.less';
import init from '@/common/init';
import initSa from '@/common/init-sa';
import { UIC_HOST, API_HOST } from './config/host';
import probes from '@xl/sec-sign-sdk';

Vue.config.productionTip = false;

// 初始化 store 数据，app 通用参数初始化
store.dispatch('initAppStore');

// 通用初始化
init(Vue);

// 神策初始化
initSa(Vue);

// 监听页面隐藏
if ('onpagehide' in window) {
  window.addEventListener('pageshow', function () {
    store.commit('setAppVal', { pageShow: true });
  });
  window.addEventListener('pagehide', function () {
    store.commit('setAppVal', { pageShow: false });
  });
}

// 接口签名服务
probes.init({
  allowList: [UIC_HOST, API_HOST].map((url) => {
    url.replace(/(?:[^./]+\.){2}[^/]+/, (str) => {
      return str;
    });

    return url;
  }),
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
